import cx from 'classnames'
import Head from 'next/head'
import Link from 'next/link'
import React, { useContext } from 'react'

import { buildActionAnalyticsAttributes } from '@mondough/analytics-v2'
import { useCopy } from '@mondough/copy'
import { Title } from '@mondough/monzo-ui'

import { AuthContext } from '../../providers'
import { Button } from '../'
import styles from './PlainLayout.module.scss'
import { PlainLayoutProps } from './PlainLayout.types'

const PlainLayout: React.FC<PlainLayoutProps> = ({
  pageTitle,
  displayTitle = true,
  displayBreadcrumb = true,
  displayCardLayout = true,
  children,
  className,
}: PlainLayoutProps) => {
  const { isSessionUpgraded } = useContext(AuthContext)
  const [displayButton, setDisplayButton] = React.useState(false)
  const c = useCopy()
  const headTitle = c.string({
    key: 'app_tabs_monzo_me.common.app_name',
    message: 'Monzo Split',
  })

  React.useEffect(() => {
    setDisplayButton(isSessionUpgraded && displayBreadcrumb)
  }, [displayBreadcrumb, isSessionUpgraded])

  return (
    <>
      <Head>
        <title>{pageTitle ? `${headTitle} | ${pageTitle}` : headTitle}</title>
      </Head>
      <section className={cx(styles.container, className)}>
        {displayButton && (
          <Link href={'/'} legacyBehavior>
            <Button
              size="small"
              theme="invisible"
              icon="chevron-left"
              className={styles['breadcrumb']}
              {...buildActionAnalyticsAttributes('details-breadcrumb', {
                breadcrumb: c.string({
                  key: 'app_tabs_monzo_me.common.app_name',
                  message: 'Monzo Split',
                }),
              })}
            >
              {c.string({
                key: 'app_tabs_monzo_me.common.app_name',
                message: 'Monzo Split',
              })}
            </Button>
          </Link>
        )}
        {pageTitle && displayTitle && (
          <Title is={'h1'} size="medium" className={styles.heading}>
            {pageTitle}
          </Title>
        )}
        {displayCardLayout ? (
          <article className={styles.card}>{children}</article>
        ) : (
          children
        )}
      </section>
    </>
  )
}

export default PlainLayout
